export const selectPipelineStages = ({ pipelineStages }) => pipelineStages
export const selectIsPipelineStagesLoading = ({ pipelineStages: { isLoading } }) => isLoading
